export default "__VITE_ASSET__QfzGwGU6__"